module.exports = __webpack_public_path__ + "img/icon-no-stream.d8e3d76c.svg";